import { coerceNumberProperty } from "@angular/cdk/coercion";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { SelectItem } from "primeng/api";
import { UnitTreeNode } from "../../../masterscreen/model/unit-tree.model";
import { UserRole } from "../../../masterscreen/model/user-role.model";
import { MasterscreenService } from "../../../masterscreen/services/masterscreen.service";
import { SearchText } from "../../../observation/model/searchTexts.model";
import { Usertypes } from "../../../observation/model/usertypes.model";
import { ObservationService } from "../../../observation/services/observation.service";
import { SpecificationData } from "../../../shared/components/category/category.component";
import {
  UserLogInActivity, UserLogInActivityDetails,
  User,
  UserPermissionParameters
} from "../../../shared/models/user.model";
// import {
//   User,
//   UserPermissionParameters
// } from "../../../shared/models/user.model";
import { BaseService } from "../../../shared/services/base.service";
import { CommonService } from "../../../shared/services/common.service";
import { ConstantsService } from "../../../shared/services/constants.service";
import { HseErrorHandlerService } from "../../../shared/services/hse-error-handler.service";
import { NotificationsService } from "../../../shared/services/notification.service";
import { FileUtility } from "../../../shared/utility/file.utility";
import { Task } from "../../model/task.model";
import { TaskPermission } from "../../model/taskPermission.model";
import { TaskConstantsService } from "../../services/task-constants.service";
import { TaskService } from "../../services/task.service";
import { ObservationConstantsService } from "../../../observation/services/observation-constants.service";

@Component({
  selector: "ara-task",
  templateUrl: "./task.component.html",
  styleUrls: ["./task.component.css"]
})
export class TaskComponent implements OnInit {
  taskDataModel: Task;
  taskDetailsResponse: any[] = [];
  taskList: SelectItem[] = [];
  sectionName: string;
  Task = new Task();
  alertType: string;
  successDetails: string;
  result: any;
  isTaskEdit: boolean = false;
  succesResult: string;
  userResults: any;
  minDate: Date;
  todayCurrentDay: Date;
  maxDate: Date;
  RecurrenceTask: string = "1";
  reccurencePeriodDateEnabled: boolean = true;
  dayNumberEnabled: boolean = true;
  dayNumberValue: number;
  userTypes: Usertypes[] = [];
  searchTexts: SearchText;
  loggedInUserJSON: any;
  user: User;
  userRoleDetails: UserRole;
  accept: string;
  multiple: boolean;
  selectedUserEmp: User = new User();
  errorDetails: any;
  confirmMessage: any;
  taskId: number = 0;
  taskListResponse: any[] = [];
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean; }[];
  tempFiles: any[];
  dates: Date[] = [];
  maxDayNumber: number;
  monitoringMatrixNames: SelectItem[];
  validate: boolean = true;
  alertFrom: string;
  selectedIndex: any;
  showImage: boolean = false;
  taskDocuments: any[] = [];
  defaultDate: Date;
  recurrencePeriodError: boolean;
  isUserSelected: boolean;
  isOwnerSelected: boolean;
  isPartySelected: boolean;
  isVerifierSelected: boolean;
  matrixNameError: boolean;
  sectionNameError: boolean;
  preWarningDaysError: boolean;
  taskIndex: number = -1;
  isNext: boolean = true;
  isPrevious: boolean = true;
  taskIds: number[] = [];
  unitList: any;
  unitTree: any;
  selectedUnit: UnitTreeNode = new UnitTreeNode();
  disableTask: boolean = false;
  unitError: boolean;
  userPermissions: UserPermissionParameters = new UserPermissionParameters();
  taskPermission: TaskPermission = new TaskPermission();
  isMultiplier: boolean = false;
  moduleId: number;
  categoryData: any;
  specificationDetailsData: any;
  independentPermissions: any;
  taskNameError: boolean = false;
  isActive: boolean = false;
  //BOC Pritesh
  dialogHeight: string;
  dialogWidth: string;
  ReportUserId : number;
  isUpdateAllowed: boolean = false;
  ReportModule : string;
  ReportRecordId : number;
  ReportProcessId : number = 0;
  ReportclosePopup: boolean = false;
  //EOC Pritesh
  editEnabled: boolean = true;
  IsNewRecord:boolean = true;

  contracts: { label: string; value: string }[] = [];
  unitContractDetails: any[] = [];
  isHasContractDetails: boolean = true;
  isContractErrorMsg: boolean = true;
  isEmployeeUnit:boolean=true;
  isContractHolder: boolean = false;
  selectedContractId: number;
  oldRecurrencePeriod : string = "";
  newRecurrencePeriod : string = "";

  updateTaskData:any;
  retVal:boolean;
  userActivityList: UserLogInActivity[];
  constructor(
    private ref: ChangeDetectorRef,
    private taskService: TaskService,
    private baseService: BaseService,
    private commonService: CommonService,
    private hseErrorHandler: HseErrorHandlerService,
    private masterscreenService: MasterscreenService,
    private router: Router,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService,
    private translate: TranslateService,
    private observationService: ObservationService
  ) {
    this.taskDataModel = new Task();
    this.Task.RecurrenceDate = new Date();
    this.todayCurrentDay = new Date();
    this.searchTexts = new SearchText();
    this.user = new User();
    this.userRoleDetails = new UserRole();
    this.accept =
      ".jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.pdf,.PDF,.docx,.DOCX,.xlsx,.XLSX,.doc,.DOC,.pptx,.PPTX,.ppt,.PPT,.heic,.HEIC,.heif,.HEIF,.xls,.XLS";
    this.multiple = true;
    this.isMultiplier = false;
    this.specificationDetailsData = new SpecificationData();
    this.moduleId = ConstantsService.PermissionMatrixModules.Task;
    this.userActivityList = [];
  }
  
  ngOnInit() {
    this.baseService.showRootLoader = true;
    const loggedInUser = this.baseService.getItemFromSession("loggedInUser");
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    let routes = JSON.stringify(
      TaskConstantsService.TaskNavigation.InnerRoutes
    );
     

    this.routesFlag = JSON.parse(routes);
    this.reportRoutes = TaskConstantsService.TaskNavigation.ReportRoutes;
    // this.RecurrencePeriod = "Monthly";
    const apiRequestUnit = {
      Model: {
        ModuleId: ConstantsService.PermissionMatrixModules.Task,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : this.IsNewRecord
      }
    };
    this.masterscreenService.getUnits(
      apiRequestUnit,
      this.callbackMethodForUnitDetails.bind(this)
    );
    this.route.params.subscribe(params => {
      this.taskId = coerceNumberProperty(params["taskId"]);
    });
    if (this.taskId !== 0 && this.taskId) {
      
      this.IsNewRecord = false;
      
    }
    const todaysDate = new Date();
    this.defaultDate = new Date(todaysDate.getFullYear() + 1, 0, 1);
    this.independentPermissions = JSON.parse(
      this.baseService.getItemFromSession("UserIndependentPermissions")
    );
    if (
      !this.independentPermissions.TSK_Add &&
      !this.independentPermissions.TSK_Add_Unit &&
      !this.independentPermissions.TSK_Admin &&
      !this.independentPermissions.TSK_Admin_Unit
    ) {
      this.routesFlag.find(s => s.routeName == "Task Setup").isClickable = false;
    }
    this.baseService.translatorListener.subscribe(data => {
      this.translate.use(data);
    });
    this.disableTask = false;
  }
  callbackMethodForUnitDetails(response) {
    if (response.Success) {
      this.unitList = response.Result;
      const apiRequest = {
        Model: {
          GetActiveNodes: this.IsNewRecord,
          UserId: this.loggedInUserJSON.UserId,
        }
      };
      this.masterscreenService.getTreeData(
        apiRequest,
        this.callbackMethodForGetTreeData.bind(this)
      );
    }
    this.baseService.showRootLoader = false;
  }
  callbackMethodForGetTreeData(response) {
    if (response.Result !== null) {
      this.unitTree = response.Result;
      if (this.taskId === 0) {
        this.unitTree.forEach(element => {
          this.compareTreeNode(element, 0);
        });
      }
    }
    this.masterscreenService.getAllMonitoringMatrixName(
      null,
      this.callbackMethodForGetAllMonitoringMatrixName.bind(this)
    );
  }
  compareTreeNode(node, selectedNode) {
    var isFound: boolean = false;
    this.unitList.forEach(element => {
      if (element.UnitId === node.UnitId) {
        isFound = true;
      }
    });
    if (!isFound || !node.IsActive) {
      node.selectable = false;
      node.expanded = false;
    }
    if (node.ParentId !== 0) {
      node.expanded = false;
    }
    if (node.UnitId === selectedNode) {
      this.selectedUnit = node;
      this.expandParents(this.selectedUnit);
    }
    if (node.children && node.children.length > 0) {
      node.selectable = false;
      node.children.forEach(element => {
        var isFound: boolean = false;
        this.unitList.forEach(unit => {
          if (unit.UnitId === element.UnitId) {
            isFound = true;
          }
        });
        if (!isFound || !element.IsActive) {
          element.selectable = false;
          element.expanded = false;
        }
        if (element.ParentId !== 0) {
          element.expanded = false;
        }
        if (element.UnitId === selectedNode) {
          this.selectedUnit = element;
          this.expandParents(this.selectedUnit);
        }
        if (element.children && element.children.length > 0) {
          this.compareTreeNode(element, selectedNode);
        }
      });
    }
  }
  expandParents(node) {
    if (node.parent) {
      node.parent.expanded = true;
      this.expandParents(node.parent);
    }
  }
  callbackMethodForGetAllMonitoringMatrixName(response) {
    this.monitoringMatrixNames = [];
    response.Result.forEach(element => {
      this.monitoringMatrixNames.push({
        label: element.MatrixName,
        value: element.MatrixId
      });
    });
    this.baseService.showRootLoader = false;
    if (this.taskId > 0) {
      this.getTaskDataById();
    }
  }
  // Shows error message when service is not available ( WebAPIs are not in running mode)
  serviceError() {
    this.hseErrorHandler.handleError(
      "Service (WebAPI) is not available or not in running mode"
    );
  }
  getIsActiveUnit(unitId) {
    
    const apiRequestUnit = {
      Model: {
        UnitId: unitId,  
      },
    };
    this.masterscreenService.getIsActiveUnit(
      apiRequestUnit,
      this.callbackMethodForgetIsActiveUnit.bind(this)
    );
  }

  callbackMethodForgetIsActiveUnit(response) {

    this.editEnabled = response.Result[0].IsActive;
    
  }
  getSectionData() {
    this.matrixNameError = false;
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        MatrixId: [this.Task.MatrixId]
      }
    };
    this.taskService.getTask(
      apiRequest,
      this.callbackMethodForGetTaskSection.bind(this)
    );
  }
  callbackMethodForGetTaskSection(response) {
    this.taskList = [];
    let count = 0;
    if (response.Success && response.Result.length > 0) {
      this.taskDetailsResponse = response.Result;
      this.taskDetailsResponse.forEach(item => {
        this.taskList.push({
          label: item.SectionName,
          value: item.SectionId
        });
        if(item.SectionId == this.Task.SectionId)
        {
          count = count + 1;
        }
      });
    }
    if(count < 1)
    {
      this.Task.SectionId = 0;
    }
    this.baseService.showRootLoader = false;
  }

  checkTaskActivity(isNewTask) {
    this.Task.isNewTask = isNewTask;
    if (this.isTaskEdit) {
      this.succesResult = "Enter again";
    } else {
      this.submitTaskDetails();
    }
  }
  onSelectDate() {
    if (this.Task.RecurrencePeriod === "Monthly") {
      this.dayNumberValue = this.Task.RecurrenceDate.getDate();
      this.Task.DayNumber = this.dayNumberValue;
    } else if (this.Task.RecurrencePeriod === "Weekly") {
      this.dayNumberValue = this.Task.RecurrenceDate.getDay() + 1;
      this.Task.DayNumber = this.dayNumberValue;
    }
  }
  submitTaskDetails() {
    if (this.checkValidation()) {
      this.Task.UnitId = this.selectedUnit.UnitId;
      this.Task.RecurrenceTask = parseInt(this.RecurrenceTask);
      this.Task.TaskOwner = this.selectedUserEmp.UserId;
      this.Task.UserId = this.loggedInUserJSON.UserId;
      this.Task.ContractId=this.isEmployeeUnit?0: this.selectedContractId;
      this.dates.forEach(date => {
        date = this.adjustForTimezone(date);
      });
      this.Task.Dates = this.dates;
      let tempDayNumber = this.Task.DayNumber;
      if (this.RecurrenceTask === "1") {
        switch (this.Task.RecurrencePeriod) {
          case "Monthly":
            let date = new Date(this.defaultDate);
            let dateToInsert = new Date(date.setDate(this.Task.DayNumber));
            if (dateToInsert < date) {
              dateToInsert.setMonth(date.getMonth() + 1);
            }
            this.Task.RecurrenceDate = this.adjustForTimezone(dateToInsert);
            break;
          case "Quarterly":
            let date1 = new Date(this.defaultDate);
            let quarter = Math.floor((date1.getMonth() + 3) / 3);
            let dateToInsert1: any = [];
            dateToInsert1 = new Date(date1.getFullYear(), (quarter - 1) * 3, 1);
            let daysInMonth = this.daysInMonth(
              dateToInsert1.getMonth() + 1,
              date1.getFullYear()
            );
            if (tempDayNumber > daysInMonth) {
              do {
                tempDayNumber = tempDayNumber - daysInMonth;
                dateToInsert1.setMonth(dateToInsert1.getMonth() + 1);
                daysInMonth = this.daysInMonth(
                  dateToInsert1.getMonth() + 1,
                  date1.getFullYear()
                );
              } while (tempDayNumber > daysInMonth);
            }
            dateToInsert1 = new Date(dateToInsert1.setDate(tempDayNumber));
            if (dateToInsert1 < date1) {
              dateToInsert1.setMonth(dateToInsert1.getMonth() + 3);
            }
            dateToInsert1.setHours(date1.getHours());
            dateToInsert1.setMinutes(date1.getMinutes());
            dateToInsert1.setSeconds(date1.getSeconds());
            this.Task.RecurrenceDate = this.adjustForTimezone(dateToInsert1);
            break;
          case "Weekly":
            let date2 = new Date(this.defaultDate);
            let dateToInsert2 = new Date(this.defaultDate);
            let dayInWeek = dateToInsert2.getDay();
            let currentDate = date2.getDate();
            tempDayNumber = tempDayNumber - 1;
            if (tempDayNumber !== dayInWeek) {
              do {
                dateToInsert2.setDate(currentDate + 1);
                currentDate++;
                dayInWeek = dateToInsert2.getDay();
              } while (tempDayNumber !== dayInWeek);
            }
            this.Task.RecurrenceDate = this.adjustForTimezone(dateToInsert2);
            break;
          case "Daily":
            this.Task.RecurrenceDate = this.adjustForTimezone(
              new Date(this.defaultDate)
            );
            break;
        }
      }
      if(this.RecurrenceTask === "2")
      {
        this.Task.RecurrenceDate = this.adjustForTimezone(this.defaultDate);
        this.Task.RecurrencePeriod = "";
      }
      this.Task.IsDraft = false;
      this.Task.ActionOwnerId = this.Task.ActionOwner.UserId;
      this.Task.ActionPartyId = this.Task.ActionParty.UserId;
      this.Task.ActionVerifierId =
        this.Task.ActionVerifier !== null ? this.Task.ActionVerifier.UserId : 0;
      this.Task.MatrixStartDate = this.adjustForTimezone(this.defaultDate);
      if (this.categoryData && this.categoryData.length > 0) {
        this.submitSpecificationData();
      }
      const apiRequest = {
        Model: this.Task
      };
      
      this.taskService.saveTask(
        apiRequest,
        this.callbackMethodForSaveTaskSection.bind(this)
      );
    } else {
      //this.alertType = ConstantsService.Error;
      //this.errorDetails = 'Please fill all mandatory fields';
      this.baseService.showRootLoader = false;
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Please fill all mandatory fields"
      );
      this.alertFrom = "Validate";
    }
  }

  ConfirmUpdate()
  {
    if (this.checkValidation()) 
    {
      this.newRecurrencePeriod = this.RecurrenceTask === "2" ? "" :  this.Task.RecurrencePeriod;
      if(this.newRecurrencePeriod !== this.oldRecurrencePeriod)
      {
      this.baseService.showRootLoader = false;  
      this.alertFrom = "UpdateTask";
      this.alertType = ConstantsService.Confirm;
      this.confirmMessage = "You are going to change the existing schedule.\nThis will delete the existing schedule and associated actions and will create new schedule and actions.\nAre you sure you want to update?";
      }
      else
      {
        this.updateTaskDetails();
      }
    }
    else 
    {
      this.baseService.showRootLoader = false;
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Please fill all mandatory fields"
      );
      this.alertFrom = "Validate";
    }
  } 

  updateTaskDetails() {
    //if (this.checkValidation()) {
      this.baseService.showRootLoader = true;  
      this.Task.UnitId = this.selectedUnit.UnitId;
      this.Task.RecurrenceTask = parseInt(this.RecurrenceTask);
      this.Task.TaskOwner = this.selectedUserEmp.UserId;
      this.Task.UserId = this.loggedInUserJSON.UserId;
      this.Task.ContractId=this.isEmployeeUnit?0: this.selectedContractId;
      this.dates.forEach(date => {
        date = this.adjustForTimezone(date);
      });
      this.Task.Dates = this.dates;
      let tempDayNumber = this.Task.DayNumber;
      if (this.RecurrenceTask === "1") {
        switch (this.Task.RecurrencePeriod) {
          case "Monthly":
            let date = new Date(this.defaultDate);
            let dateToInsert = new Date(date.setDate(this.Task.DayNumber));
            if (dateToInsert < date) {
              dateToInsert.setMonth(date.getMonth() + 1);
            }
            this.Task.RecurrenceDate = this.adjustForTimezone(dateToInsert);
            break;
          case "Quarterly":
            let date1 = new Date(this.defaultDate);
            let quarter = Math.floor((date1.getMonth() + 3) / 3);
            let dateToInsert1: any = [];
            dateToInsert1 = new Date(date1.getFullYear(), (quarter - 1) * 3, 1);
            let daysInMonth = this.daysInMonth(
              dateToInsert1.getMonth() + 1,
              date1.getFullYear()
            );
            if (tempDayNumber > daysInMonth) {
              do {
                tempDayNumber = tempDayNumber - daysInMonth;
                dateToInsert1.setMonth(dateToInsert1.getMonth() + 1);
                daysInMonth = this.daysInMonth(
                  dateToInsert1.getMonth() + 1,
                  date1.getFullYear()
                );
              } while (tempDayNumber > daysInMonth);
            }
            dateToInsert1 = new Date(dateToInsert1.setDate(tempDayNumber));
            if (dateToInsert1 < date1) {
              dateToInsert1.setMonth(dateToInsert1.getMonth() + 3);
            }
            dateToInsert1.setHours(date1.getHours());
            dateToInsert1.setMinutes(date1.getMinutes());
            dateToInsert1.setSeconds(date1.getSeconds());
            this.Task.RecurrenceDate = this.adjustForTimezone(dateToInsert1);
            break;
          case "Weekly":
            let date2 = new Date(this.defaultDate);
            let dateToInsert2 = new Date(this.defaultDate);
            let dayInWeek = dateToInsert2.getDay();
            let currentDate = date2.getDate();
            tempDayNumber = tempDayNumber - 1;
            if (tempDayNumber !== dayInWeek) {
              do {
                dateToInsert2.setDate(currentDate + 1);
                currentDate++;
                dayInWeek = dateToInsert2.getDay();
              } while (tempDayNumber !== dayInWeek);
            }
            this.Task.RecurrenceDate = this.adjustForTimezone(dateToInsert2);
            break;
          case "Daily":
            this.Task.RecurrenceDate = this.adjustForTimezone(
              new Date(this.defaultDate)
            );
            break;
        }
      }
      if(this.RecurrenceTask === "2")
      {
        this.Task.RecurrenceDate = this.adjustForTimezone(this.defaultDate);
        this.Task.RecurrencePeriod = "";
      }
      this.Task.IsDraft = false;
      this.Task.ActionOwnerId = this.Task.ActionOwner.UserId;
      this.Task.ActionPartyId = this.Task.ActionParty.UserId;
      this.Task.ActionVerifierId =
        this.Task.ActionVerifier !== null ? this.Task.ActionVerifier.UserId : 0;
      this.Task.MatrixStartDate = this.adjustForTimezone(this.defaultDate);
      if (this.categoryData && this.categoryData.length > 0) {
        this.submitSpecificationData();
      }
      const apiRequest = {
        Model: this.Task
      };
      
      this.taskService.updateTask(
        apiRequest,
        this.callbackMethodForSaveTaskSection.bind(this)
      );
    //} 
    // else {
    //   //this.alertType = ConstantsService.Error;
    //   //this.errorDetails = 'Please fill all mandatory fields';
    //   this.baseService.showRootLoader = false;
    //   this.notificationsService.toastNotify(
    //     "error",
    //     "Error Message",
    //     "Please fill all mandatory fields"
    //   );
    //   this.alertFrom = "Validate";
    // }
  }

  checkValidation(): boolean {
    this.baseService.showRootLoader = true;
    let isValid = true;
    this.unitError = false;
    if (!this.selectedUnit.UnitId) {
      this.unitError = true;
      isValid = false;
    }
    this.matrixNameError = false;
    if (!this.Task.MatrixId) {
      this.matrixNameError = true;
      isValid = false;
    }
    this.sectionNameError = false;
    if (!this.Task.SectionId) {
      this.sectionNameError = true;
      isValid = false;
    }
    this.taskNameError = false;
    if (!this.Task.Name) {
      this.taskNameError = true;
      isValid = false;
    }
    this.recurrencePeriodError = false;
    if (this.RecurrenceTask === "1") {
      if (!this.Task.RecurrencePeriod) {
        this.recurrencePeriodError = true;
        isValid = false;
      }
      if (!this.Task.Multiplier) {
        isValid = false;
      }
      if (
        this.dayNumberEnabled &&
        (this.Task.DayNumber < 1 || this.Task.DayNumber > this.maxDayNumber)
      ) {
        isValid = false;
      }
    }
    
    if (this.RecurrenceTask === "2") {
      if (!this.dates) {
        isValid = false;
      }
    }
    this.isUserSelected = false;
    if (this.selectedUserEmp.UserId === 0) {
      this.isUserSelected = true;
      isValid = false;
    }
    this.preWarningDaysError = false;
    if (this.Task.TaskPrewarningDays < 0) {
      this.preWarningDaysError = true;
      isValid = false;
    }
    if (this.Task.ActionOwner.UserId === 0) {
      this.isOwnerSelected = true;
      isValid = false;
    }
    if (this.Task.ActionParty.UserId === 0) {
      this.isPartySelected = true;
      isValid = false;
    }
    // if (this.Task.ActionVerifier.UserId === 0) {
    //   this.isVerifierSelected = true;
    //   isValid = false;
    // }
    return isValid;
  }
  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }
  callbackMethodForSaveTaskSection(response) {
    if (response && response.Success) {
      //this.alertType = ConstantsService.Success;
      this.result = response.Result;
      this.alertFrom = "SaveOrUpdate";
      if(this.Task.TaskId>0){
      this.updateTaskData = JSON.parse(
        this.taskService.getUpdatedTaskData()
      );     
     
      this.trackDetails(
        this.updateTaskData,
        this.taskDataModel,
        "UpdateAction",
        false
      );}

      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        this.Task.TaskId !== 0
          ? "Task has been updated successfully"
          : "Task has been saved successfully"
      );
      if (this.Task.TaskId === 0) {
        this.alertType = ConstantsService.Confirm;
        this.confirmMessage = "Do you want to duplicate the task?";
      }
      this.baseService.showRootLoader = false;
      if(this.Task.TaskId !== 0)
      {
      this.navigateToOverview();
      }
      //this.successDetails = this.Task.TaskId !== 0 ? 'Task has been' + ' ' + 'updated successfully' : 'Task has been saved successfully';
    } else {
      //this.alertType = ConstantsService.Error;
      //this.errorDetails = "Something went wrong!";
      this.alertFrom = "SaveError";
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something went wrong!"
      );
    }
    this.baseService.showRootLoader = false;
  }

  trackDetails(OldValue, NewValue, action, isNew) {
    const columnNames = Object.getOwnPropertyNames(this.taskDataModel);
    columnNames.forEach((element) => {
      if (OldValue.length === 0) {
        this.retVal = false;
        // OldValue = null;
      } else {
        this.retVal = this.commonService.isDataEqual(
          OldValue[element],
          NewValue[element]
        );
      }
      if (this.retVal === false) {
        switch (action) {
          case "UpdateAction":
            if (element === "UnitId") {
              this.retVal = this.commonService.isDataEqual(
               OldValue[element],
               NewValue[element]
             );
             
             if (this.retVal === false) {
               const userLoginActivity = new UserLogInActivity();
               userLoginActivity.FieldName = "Unit";
               userLoginActivity.OldValue = isNew ? null : OldValue[element];
               userLoginActivity.NewValue = NewValue[element];
               if(OldValue.UnitId != NewValue.UnitId){
               this.userActivityList.push(userLoginActivity);}
             }
           }else if (element === "MatrixId") {
      
            const userLoginActivity = new UserLogInActivity();
            userLoginActivity.FieldName = "Monitoring Matrix";
            userLoginActivity.OldValue = isNew ? null : OldValue[element];
            userLoginActivity.NewValue = NewValue[element];
            this.userActivityList.push(userLoginActivity);
          
        }else if (element === "SectionId") {
      
          const userLoginActivity = new UserLogInActivity();
          userLoginActivity.FieldName = "Section";
          userLoginActivity.OldValue = isNew ? null : OldValue[element];
          userLoginActivity.NewValue = NewValue[element];
          this.userActivityList.push(userLoginActivity);
        
      }else if (element === "Name" ||
      element === "TaskDescription" ||
      element === "RecurrencePeriod" ||
      element === "Multiplier" ||
      element === "DayNumber" ||
      element === "TaskOwner" ||
      element === "TaskPrewarningDays"
      ) {
      
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = element;
        userLoginActivity.OldValue = isNew ? null : OldValue[element];
        userLoginActivity.NewValue = NewValue[element];
        this.userActivityList.push(userLoginActivity);
      
    }
  //   else if (element === "TaskDescription") {
      
  //     const userLoginActivity = new UserLogInActivity();
  //     userLoginActivity.FieldName = element;
  //     userLoginActivity.OldValue = isNew ? null : OldValue[element];
  //     userLoginActivity.NewValue = NewValue[element];
  //     this.userActivityList.push(userLoginActivity);
    
  // }
  // else if (element === "RecurrenceTask") {      
  //   const userLoginActivity = new UserLogInActivity();
  //   userLoginActivity.FieldName = element;
  //   userLoginActivity.OldValue = isNew ? null : OldValue[element];
  //   userLoginActivity.NewValue = NewValue[element];
  //   this.userActivityList.push(userLoginActivity);
  // }
//   else if (element === "RecurrencePeriod") {
      
//   const userLoginActivity = new UserLogInActivity();
//   userLoginActivity.FieldName = element;
//   userLoginActivity.OldValue = isNew ? null : OldValue[element];
//   userLoginActivity.NewValue = NewValue[element];
//   this.userActivityList.push(userLoginActivity);

// }
// else if (element === "Multiplier") {
      
//   const userLoginActivity = new UserLogInActivity();
//   userLoginActivity.FieldName = element;
//   userLoginActivity.OldValue = isNew ? null : OldValue[element];
//   userLoginActivity.NewValue = NewValue[element];
//   this.userActivityList.push(userLoginActivity);

// }
// }
// else if (element === "TaskOwner") {
      
//   const userLoginActivity = new UserLogInActivity();
//   userLoginActivity.FieldName = element;
//   userLoginActivity.OldValue = isNew ? null : OldValue[element];
//   userLoginActivity.NewValue = NewValue[element];
//   this.userActivityList.push(userLoginActivity);

//}
//  else if (element === "TaskPrewarningDays") {
      
//   const userLoginActivity = new UserLogInActivity();
//   userLoginActivity.FieldName = element;
//   userLoginActivity.OldValue = isNew ? null : OldValue[element];
//   userLoginActivity.NewValue = NewValue[element];
//   this.userActivityList.push(userLoginActivity);

// }

else if (element === "TaskFileDescription") {
  const userLoginActivity = new UserLogInActivity();
  userLoginActivity.FieldName = element;
  if (this.updateTaskData[element] != null) {
    for (var i = 0; i < this.updateTaskData[element].length; i++) {
      const url = this.updateTaskData.TaskFileDescription[i].Name;
      userLoginActivity.OldValue += url + ",";
    }
  } else {
    userLoginActivity.OldValue = null;
  }
  for (var i = 0; i < this.taskDataModel[element].length; i++) {
    let url1 = this.taskDataModel.TaskFileDescription[i].Name;
    ;
    
    userLoginActivity.NewValue += url1 + ",";
  }
  if(userLoginActivity.OldValue !== userLoginActivity.NewValue)
  {
  this.userActivityList.push(userLoginActivity);
  }
}  else if (element === "MatrixStartDate") {     
  const userLoginActivity = new UserLogInActivity();
  userLoginActivity.FieldName = element;
  userLoginActivity.OldValue =moment(moment.utc(OldValue[element]).local()).format('DD/MM/YYYY');// isNew ? null : OldValue[element];
  userLoginActivity.NewValue =moment(moment.utc(NewValue[element]).local()).format('DD/MM/YYYY');// NewValue[element];
  if(userLoginActivity.OldValue!=userLoginActivity.NewValue){
  this.userActivityList.push(userLoginActivity);
}
} else  if (element === "ActionOwner") {
  this.retVal = this.commonService.isDataEqual(
    OldValue[element],
    NewValue[element]
  );
  if (this.retVal === false) {
    const userLoginActivity = new UserLogInActivity();
            userLoginActivity.FieldName = element;
            userLoginActivity.OldValue = OldValue ? OldValue[element].FullName : null;
            userLoginActivity.NewValue = this.taskDataModel.ActionOwner.FullName;
            if( userLoginActivity.OldValue !=userLoginActivity.NewValue){
            this.userActivityList.push(userLoginActivity);}
  }
}else  if (element === "ActionParty") {
  this.retVal = this.commonService.isDataEqual(
    OldValue[element],
    NewValue[element]
  );
  if (this.retVal === false) {
    const userLoginActivity = new UserLogInActivity();
            userLoginActivity.FieldName = element;
            userLoginActivity.OldValue = OldValue ? OldValue[element].FullName : null;
            userLoginActivity.NewValue = this.taskDataModel.ActionParty.FullName;
            if( userLoginActivity.OldValue !=userLoginActivity.NewValue){
            this.userActivityList.push(userLoginActivity);}
  }
}   else  if (element === "ActionVerifier") {
  this.retVal = this.commonService.isDataEqual(
    OldValue[element],
    NewValue[element]
  );
  if (this.retVal === false) {
    const userLoginActivity = new UserLogInActivity();
            userLoginActivity.FieldName = element;
            userLoginActivity.OldValue = OldValue ? OldValue[element].FullName : null;
            userLoginActivity.NewValue = this.taskDataModel.ActionVerifier.FullName;
            if( userLoginActivity.OldValue !=userLoginActivity.NewValue){
            this.userActivityList.push(userLoginActivity);}
  }
}else if (element === "Dates") {
  const userLoginActivity = new UserLogInActivity();
  userLoginActivity.FieldName = element;
  if (this.updateTaskData) {
    for (var i = 0; i < this.updateTaskData[element].length; i++) {
      const url = moment(moment.utc(this.updateTaskData.Dates[i]).local()).format('DD/MM/YYYY');//this.updateTaskData.Dates[i];
      userLoginActivity.OldValue += url + ",";
    }
  } else {
    userLoginActivity.OldValue = null;
  }
  for (var i = 0; i < this.taskDataModel[element].length; i++) {
    let url1 =moment(moment.utc(this.taskDataModel.Dates[i]).local()).format('DD/MM/YYYY');// this.taskDataModel.Dates[i];
    ;
    
    userLoginActivity.NewValue += url1 + ",";
  }
  if(userLoginActivity.OldValue !== userLoginActivity.NewValue)
  {
  this.userActivityList.push(userLoginActivity);
  }
}else if (element === "RecurrenceTask") {
  this.retVal = this.commonService.isDataEqual(
    OldValue[element],
    NewValue[element]
  );
  if (this.retVal === false) {
    const userLoginActivity = new UserLogInActivity();
    userLoginActivity.FieldName = element;
     
      userLoginActivity.OldValue = this.changeStatus(
        OldValue[element]
      );
      userLoginActivity.NewValue = this.changeStatus(
        NewValue[element]
      );

      this.userActivityList.push(userLoginActivity);
    
  }
}
}
}
});
    if (this.userActivityList.length > 0) {
      this.commonService.saveUserActivityDetails(
        this.taskDataModel.TaskId,
            new Date(),
            "Task",
            this.loggedInUserJSON.UserId,
            this.userActivityList
      );
    }
  }
  changeStatus(priorityToFormat) {
    let strPriority = null;
    switch (priorityToFormat) {
      case 1:
        strPriority = "Recurring";
        break;
      case 2:
        strPriority = "Non-Recurring";
        break;
        
    }
    return strPriority;
  }
  getUsersOnSearch(event) {
    this.searchTexts.FilterTexts = event.query;
    this.searchTexts.CompanyId = 0;
    this.searchTexts.UserTypeId = 0;
    this.searchTexts.UnitId = this.selectedUnit.UnitId;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.commonService.getSearchResultsForUsers(
      apiRequest,
      this.callbackMethodForGetSearchResultsForUsersData.bind(this)
    );
  }

  // call back method of employee on search
  callbackMethodForGetSearchResultsForUsersData(response) {
    if (response === undefined) {
      this.serviceError();
    }
    if (response.Success) {
      const filtered: any[] = [];
      for (let i = 0; i < response.Result.length; i++) {
        this.user = response.Result[i];
        if (
          this.user.FullName.toLowerCase().indexOf(
            this.searchTexts.FilterTexts.toLowerCase()
          ) !== -1
        ) {
          filtered.push(this.user);
        }
      }
      this.userResults = filtered;
    }
    if (response.Errors !== null) {
      this.hseErrorHandler.handleError(response.Errors);
    }
  }
  selectUser(event) {
    if (!event.UserId) {
      this.selectedUserEmp.UserId = 0;
    } else {
      this.selectedUserEmp = {
        UserId: event.UserId,
        FullName: event.FullName,
        Email: event.Email,
        FirstName: event.FirstName,
        LastName: event.LastName,
        UserTypeId: event.UserTypeId,
        UserTypes: event.UserTypes,
        ContactNumber: event.ContactNumber,
        Designation: event.Designation,
        DepartmentName: event.DepartmentName,
            ContractNumber:event.contractNumber,
            UserTypeName:event.userTypeName
      };
    }
    this.isUserSelected = false;
  }
  selectActionOwner(event) {
    if (!event.UserId) {
      this.Task.ActionOwner.UserId = 0;
    } else {
      this.Task.ActionParty = new User();
      // this.Task.ActionParty = {
      //   UserId: event.UserId,
      //   FullName: event.FullName,
      //   Email: event.Email,
      //   FirstName: event.FirstName,
      //   LastName: event.LastName,
      //   UserTypeId: event.UserTypeId,
      //   UserTypes: event.UserTypes,
      //   ContactNumber: event.ContactNumber,
      //   Designation: event.Designation,
      //   DepartmentName: event.DepartmentName,
      //   UserTypeName: event.userTypeName,
      //   ContractNumber: event.ContractNumber,
      // };
    }
    this.isOwnerSelected = false;
  }
  selectActionParty(event) {
    if (!event.UserId) {
      this.Task.ActionParty.UserId = 0;
    }
    this.isPartySelected = false;
  }
  selectActionVerifier(event) {
    if (!event.UserId) {
      this.Task.ActionVerifier.UserId = 0;
    }
    this.isVerifierSelected = false;
  }
  resetPeoplePicker() {
    this.userRoleDetails.userId = null;
  }
  checkOccurrence(selectedRecurrencePeriod) {
    let selectedRecurrencePeriodType = selectedRecurrencePeriod.target.value;
    if (selectedRecurrencePeriodType === "Monthly") {
      this.dayNumberEnabled = true;
      this.maxDayNumber = 31;
      this.Task.Multiplier = 12;
      this.Task.TaskPrewarningDays = 30;
      this.Task.DayNumber = 30;
    } else if (selectedRecurrencePeriodType === "Quarterly") {
      this.dayNumberEnabled = true;
      this.maxDayNumber = 92;
      this.Task.Multiplier = 4;
      this.Task.TaskPrewarningDays = 90;
      this.Task.DayNumber = 90;
    } else if (selectedRecurrencePeriodType === "Daily") {
      this.dayNumberEnabled = false;
      this.Task.Multiplier = 365;
      this.Task.TaskPrewarningDays = 1;
    } else if (selectedRecurrencePeriodType === "Weekly") {
      this.dayNumberEnabled = true;
      this.maxDayNumber = 7;
      this.Task.Multiplier = 52;
      this.Task.TaskPrewarningDays = 7;
      this.Task.DayNumber = 7;
    }
    this.recurrencePeriodError = false;
  }
  getTaskDataById() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        TaskId: this.taskId
      }
    };
    this.taskService.getTaskDataById(
      apiRequest,
      this.callbackMethodForGetTaskData.bind(this)
    );
  }
  callbackMethodForGetTaskData(response) {
    if (response.Success) {

      this.taskDataModel = response.Result;
      
      this.taskService.setUpdatedTaskData(
        JSON.stringify(this.taskDataModel)
        );
    //   if (this.loggedInUserJSON.UserTypes.UserType ===
    //     ObservationConstantsService.RequestFor.Contractor && response.Result.CreatedBy != this.loggedInUserJSON.UserId
    //  ) {
    //    this.notificationsService.toastNotify(
    //      "error",
    //      "Warning Message",
    //      "This Task not raised by you, you don't have permission to view this record...!"
    //    );  
    //    this.router.navigate(["task/task-list"]);
    //    return ;
    //  }
      this.Task = response.Result;
      this.oldRecurrencePeriod = this.Task != null ? this.Task.RecurrencePeriod : "";
      this.Task.TaskOwner = this.Task.TaskOwnerUser.UserId;
      this.isActive = this.Task.Status === "New" ? true : false;
      this.getPermissionDetails(this.Task.UnitId);
      this.getIsActiveUnit(this.Task.UnitId);
      this.unitTree.forEach(element => {
        this.compareTreeNode(element, this.Task.UnitId);
      });
      this.isEmployeeUnit=true;
      if(this.selectedUnit.UnitTypeId == 2)
      {
        this.isEmployeeUnit=false;
        this.getContractDetails(this.selectedUnit.UnitId);
      }
      this.selectedContractId=this.Task.ContractId;
      if (this.Task.TaskFileDescription) {
        this.taskDocuments = this.Task.TaskFileDescription;
        this.ref.detectChanges();
        this.Task.TaskFileDescription = this.Task.TaskFileDescription;
      } else {
        this.Task.TaskFileDescription = [];
      }
      if (this.Task.RecurrenceTask === 1) {
        if (this.Task.RecurrencePeriod === "Daily") {
          this.reccurencePeriodDateEnabled = false;
          this.dayNumberEnabled = false;
        } else if (this.Task.RecurrencePeriod === "Quarterly") {
          this.reccurencePeriodDateEnabled = false;
          this.dayNumberEnabled = true;
        }
        this.Task.RecurrenceDate = new Date(this.Task.RecurrenceDate);
      } else {
        this.Task.RecurrenceDate = new Date();
      }
      this.RecurrenceTask = this.Task.RecurrenceTask.toString();
      this.selectedUserEmp = this.Task.TaskOwnerUser;
      
      this.Task.Dates.forEach(element => {
        this.dates.push(moment(moment.utc(element).local()).toDate());
      });
      this.defaultDate = moment(
        moment.utc(this.Task.MatrixStartDate).local()
      ).toDate();
      this.getSectionData();
    } else {
      this.baseService.processApiResponseError(response);
    }
    this.taskIds = this.taskService.getAllTaskIds();
    if(this.taskIds == null){
      this.isNext = false;
      this.isPrevious = false;
    }
    let currentIndex: number = 0;
    if(this.taskIds){
      this.taskIds.forEach((element, index) => {
        if (element.toString() === this.taskId.toString()) {
          currentIndex = index;
          return;
        }
      });

      if (currentIndex === 0 || this.taskIds.length === 1) {
        this.isPrevious = false;
      }
      if (currentIndex === this.taskIds.length - 1) {
        this.isNext = false;
      }
    }
      this.baseService.showRootLoader = false;
  }

  // Reset field value
  resetValue() {
    this.Task = new Task();
    this.Task.RecurrenceDate = new Date();
    this.RecurrenceTask = "";
    this.Task.isNewTask = true;
    this.alertType = null;
    this.errorDetails = null;
    this.successDetails = null;
    this.confirmMessage = null;
    this.ngOnInit();
  }
  navigateToOverview() {
    this.router.navigate([
      TaskConstantsService.RoutingURLConstant.MyTaskOverview
    ]);
  }
  checkRecurrence() {
    
    if (this.RecurrenceTask === "1") {
      this.dates = undefined;
    } else {
      this.dates = [];
      this.Task.Multiplier = 1;
      this.Task.RecurrencePeriod = null;
    }
  }
  onOkClicked() {
    switch (this.alertFrom) {
      case "Validate":
      case "SaveError":
        break;
      case "SaveOrUpdate":
        this.Task.Name = "";
        break;
      case "TaskTurnOnOff":
        this.submitTaskDetails();
        break;
       case "UpdateTask":
        break; 
    }
    this.alertType = null;
    this.successDetails = null;
    this.confirmMessage = null;
    this.errorDetails = null;
  }
  displayImage($event, index) {
    this.showImage = $event.type === "mouseenter" ? true : false;
    if (this.showImage) {
      this.selectedIndex = index;
    }
  }
  sectionSelected() {
    this.sectionNameError = false;
  }
  adjustForTimezone(date: Date): Date {
    var timeOffsetInMS: number = date.getTimezoneOffset() * 60000;
    date.setTime(date.getTime() - timeOffsetInMS);
    return date;
  }
  onNoClickedForConfirmation() {
    switch (this.alertFrom) {
      case "Validate":
      case "SaveError":
      case "SaveOrUpdate":
        this.navigateToOverview();
        break;
      case "TaskTurnOnOff":
        this.Task.IsActive = !this.Task.IsActive;
        break;
       case "UpdateTask":
        break; 
    }
    this.alertType = null;
    this.successDetails = null;
    this.confirmMessage = null;
    this.errorDetails = null;
  }
  onPreviousClick() {
    this.taskIndex = -1;
    this.isNext = true;
    this.dates = [];
    this.disableTask = false;
    
    this.taskIds = this.taskService.getAllTaskIds();
    this.taskIds.forEach((element, index) => {
      if (element == this.taskId && index - 1 != null) {
        this.taskIndex = index - 1;
        if (this.taskIndex <= 0) {
          this.isPrevious = false;
        } else {
          this.isPrevious = true;
        }
        return;
      }
    });
    if (this.taskIndex > -1) {
      this.taskId = this.taskIds[this.taskIndex];
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          TaskId: this.taskId
        }
      };
      this.taskService.getTaskDataById(
        apiRequest,
        this.callbackMethodForGetTaskData.bind(this)
      );
      this.router.navigate(["task/create-task/" + this.taskId]);
    }
  }

  onNextClick() {
    this.isPrevious = true;
    this.taskIndex = -1;
    this.dates = [];
    this.disableTask = false;
    this.taskIds = this.taskService.getAllTaskIds();
    this.taskIds.forEach((element, index) => {
      if (element == this.taskId && index + 1 != null) {
        this.taskIndex = index + 1;
        if (this.taskIndex + 1 == this.taskIds.length) {
          this.isNext = false;
        } else {
          this.isNext = true;
        }
        return;
      }
    });
    if (this.taskIndex > -1) {
      this.taskId = this.taskIds[this.taskIndex];
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          TaskId: this.taskId
        }
      };
      this.taskService.getTaskDataById(
        apiRequest,
        this.callbackMethodForGetTaskData.bind(this)
      );
      this.router.navigate(["task/create-task/" + this.taskId]);
    }
  }
  onYesClickedForConfirmation() {
    switch (this.alertFrom) {
      case "Validate":
      case "SaveError":
      case "SaveOrUpdate":
        this.Task.Name = "";
        break;
      case "TaskTurnOnOff":
        this.submitTaskDetails();
        break;
      case "UpdateTask":
        this.updateTaskDetails();  
        break;
    }
    this.alertType = null;
    this.successDetails = null;
    this.confirmMessage = null;
    this.errorDetails = null;
  }
  nodeSelected(event) {
    this.selectedUnit = event.node;
    if (this.selectedUnit.children && this.selectedUnit.children.length > 0) {
      this.selectedUnit.expanded = true;
    }
    this.getPermissionDetails(this.selectedUnit.UnitId);
    this.isEmployeeUnit=true;
    if(event.node.UnitTypeId == 2)
    {
      this.isEmployeeUnit=false;
      this.getContractDetails(this.selectedUnit.UnitId);
    }
  }
  getContractDetails(unitId: number): void {
    const apiRequestUnit = {
      Model: {
        "UnitId": unitId
      },
    };
    this.masterscreenService.getContractDetailsData(
      apiRequestUnit,
      this.callbackMethodForContractDetails.bind(this)
    );
  }
  callbackMethodForContractDetails(response) {
     
    this.contracts = [];
    this.unitContractDetails = response;
    let contractHolderId;
    response.forEach(contract => {
      this.contracts.push({ label: contract.ContractNumber, value: contract.UnitContractDetailsId });
      
    });
    if (this.taskId !== 0 && this.taskId && this.contracts.some(c => c.value == this.Task.ContractId.toString())) {
      let currentContract = this.contracts.find(c => c.value.toString() === this.Task.ContractId.toString());
    
      this.isContractErrorMsg=false;
      this.checkHolder(currentContract);
      this.isContractHolder=false;
      if(currentContract!=null)
      {
      contractHolderId = response.find(h => h.UnitContractDetailsId.toString() === this.Task.ContractId.toString()).ContractHolderId
      this.isContractHolder = contractHolderId === this.loggedInUserJSON.UserId ? true : false;
      }
    }
    else 
    {
      this.isContractErrorMsg=true;
    }
  }
  checkHolder(event) {
    this.selectedContractId=0;
    let contract;
    contract = this.unitContractDetails.find(contract => contract.UnitContractDetailsId === event.value);
    if (contract.ContractHolderId && contract.ContractNumber != '') {
      this.isContractErrorMsg=false;
      this.isHasContractDetails = true;
      this.selectedContractId=event.value;
    } 
    else {
      this.isContractErrorMsg=true;
      this.isHasContractDetails = false;
    }
  }


  getPermissionDetails(unitId) {
    this.userPermissions.ModuleId =
      ConstantsService.PermissionMatrixModules.Task;
    this.userPermissions.UserId = this.loggedInUserJSON.UserId;
    this.userPermissions.UnitId = unitId;
    const apiRequest = {
      Model: this.userPermissions
    };
    this.commonService.getPermissionDetailsForUser(
      apiRequest,
      this.callbackMethodForgetPermissionDetails.bind(this)
    );
  }
  callbackMethodForgetPermissionDetails(response) {
    if (response.Result) {
      const permissions = response.Result;
      this.taskPermission = permissions.TaskPermission;
      this.taskPermission.TSK_Own = this.Task.TaskOwner === this.loggedInUserJSON.UserId;
      if (
        !this.taskPermission.TSK_Admin &&
        !this.taskPermission.TSK_Admin_Unit &&
        !this.taskPermission.TSK_Own &&
        this.taskId > 0
      ) {
        if(this.Task.Status === "Draft")
        {
          this.disableTask = false;
        }
        else
        {
          this.disableTask = true;
        }
      }
      if(!this.taskPermission.TSK_Add && !this.taskPermission.TSK_Add_Unit && !this.taskPermission.TSK_Admin_Unit && !this.taskPermission.TSK_Admin){
      this.isUpdateAllowed = false;
      }
      else{
        this.isUpdateAllowed = true;
      }
      if (this.Task.Status === "Cancelled" || this.Task.Status === "Deleted") {
        this.disableTask = true;
      }
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something went wrong!"
      );
    }
    this.baseService.showRootLoader = false;
  }
  downloadPDF() {
    this.notificationsService.toastNotify(
      "info",
      "Information Message",
      "Download in progress!"
    );
    const apiRequest = {
      Model: {
        ProcessName: "Task",
        SourceId: this.taskId
      }
    };
    this.taskService.downloadPDF(
      apiRequest,
      this.callbackMethodForDownloadZIP.bind(this)
    );
  }
  callbackMethodForDownloadZIP(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "pdf_task" + this.taskId + ".pdf"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);

    }
  }
  categoryCheckedEmittedValue(value) {
    this.categoryData = value;
  }
  submitSpecificationData() {
    this.specificationDetailsData.RuleId = this.categoryData;
    this.specificationDetailsData.SourceId = this.taskId;
    this.specificationDetailsData.ModuleId = this.moduleId;

    const apiRequest = {
      Model: this.specificationDetailsData
    };
    this.observationService.submitSpecificationData(
      apiRequest,
      this.callbackMethodForSubmitSpecificationData.bind(this)
    );
  }

  callbackMethodForSubmitSpecificationData(response) {
    if (response.Success) {
    }
  }
  getOutput(event) {
    if (event) {
     // this.ngOnInit();
     this.router.navigate(["task/task-list"]);
    }
  }

  getRemarks(text, type) {
    switch (type) {
      case "TaskNameText":
        this.Task.Name = text;
        break;
      case "TaskDescriptionText":
        this.Task.TaskDescription = text;
        break;
      default:
        break;
    }
  }

  taskTurnOnOff(){
    this.alertType = "Confirm";
    this.alertFrom = "TaskTurnOnOff";
    let status:string = this.Task.IsActive ? " ON ":" OFF ";
    this.confirmMessage = "Do you want to turn" + status + "task ?";
  }

  saveAsDraft() {
    if (this.checkValidation()) {
      this.Task.UnitId = this.selectedUnit.UnitId;
      this.Task.RecurrenceTask = parseInt(this.RecurrenceTask);
      this.Task.TaskOwner = this.selectedUserEmp.UserId;
      this.Task.UserId = this.loggedInUserJSON.UserId;
      this.dates.forEach(date => {
        date = this.adjustForTimezone(date);
      });
      this.Task.Dates = this.dates;
      let tempDayNumber = this.Task.DayNumber;
      if (this.RecurrenceTask === "1") {
        switch (this.Task.RecurrencePeriod) {
          case "Monthly":
            let date = new Date(this.defaultDate);
            let dateToInsert = new Date(date.setDate(this.Task.DayNumber));
            if (dateToInsert < date) {
              dateToInsert.setMonth(date.getMonth() + 1);
            }
            this.Task.RecurrenceDate = this.adjustForTimezone(dateToInsert);
            break;
          case "Quarterly":
            let date1 = new Date(this.defaultDate);
            let quarter = Math.floor((date1.getMonth() + 3) / 3);
            let dateToInsert1: any = [];
            dateToInsert1 = new Date(date1.getFullYear(), (quarter - 1) * 3, 1);
            let daysInMonth = this.daysInMonth(
              dateToInsert1.getMonth() + 1,
              date1.getFullYear()
            );
            if (tempDayNumber > daysInMonth) {
              do {
                tempDayNumber = tempDayNumber - daysInMonth;
                dateToInsert1.setMonth(dateToInsert1.getMonth() + 1);
                daysInMonth = this.daysInMonth(
                  dateToInsert1.getMonth() + 1,
                  date1.getFullYear()
                );
              } while (tempDayNumber > daysInMonth);
            }
            dateToInsert1 = new Date(dateToInsert1.setDate(tempDayNumber));
            if (dateToInsert1 < date1) {
              dateToInsert1.setMonth(dateToInsert1.getMonth() + 3);
            }
            dateToInsert1.setHours(date1.getHours());
            dateToInsert1.setMinutes(date1.getMinutes());
            dateToInsert1.setSeconds(date1.getSeconds());
            this.Task.RecurrenceDate = this.adjustForTimezone(dateToInsert1);
            break;
          case "Weekly":
            let date2 = new Date(this.defaultDate);
            let dateToInsert2 = new Date(this.defaultDate);
            let dayInWeek = dateToInsert2.getDay();
            let currentDate = date2.getDate();
            tempDayNumber = tempDayNumber - 1;
            if (tempDayNumber !== dayInWeek) {
              do {
                dateToInsert2.setDate(currentDate + 1);
                currentDate++;
                dayInWeek = dateToInsert2.getDay();
              } while (tempDayNumber !== dayInWeek);
            }
            this.Task.RecurrenceDate = this.adjustForTimezone(dateToInsert2);
            break;
          case "Daily":
            this.Task.RecurrenceDate = this.adjustForTimezone(
              new Date(this.defaultDate)
            );
            break;
        }
      }
      if(this.RecurrenceTask === "2")
      {
        this.Task.RecurrenceDate = this.adjustForTimezone(this.defaultDate);
        this.Task.RecurrencePeriod = "";
      }
      this.Task.IsDraft = true;
      this.Task.ActionOwnerId = this.Task.ActionOwner.UserId;
      this.Task.ActionPartyId = this.Task.ActionParty.UserId;
      this.Task.ActionVerifierId =
        this.Task.ActionVerifier !== null ? this.Task.ActionVerifier.UserId : 0;
      this.Task.MatrixStartDate = this.adjustForTimezone(this.defaultDate);
      this.Task.ContractId = this.isEmployeeUnit?0: this.selectedContractId;
      if (this.categoryData && this.categoryData.length > 0) {
        this.submitSpecificationData();
      }
      const apiRequest = {
        Model: this.Task
      };
      this.taskService.saveTask(
        apiRequest,
        this.callbackMethodForSaveTaskSection.bind(this)
      );
    } else {
      //this.alertType = ConstantsService.Error;
      //this.errorDetails = 'Please fill all mandatory fields';
      this.baseService.showRootLoader = false;
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Please fill all mandatory fields"
      );
      this.alertFrom = "Validate";
    }
  }

   //BOC Pritesh
   ReportshowDialog() {
    
    this.ReportUserId = this.loggedInUserJSON.UserId;
    this.ReportModule = "Task";
    this.ReportRecordId = this.Task.TaskId;
    this.ReportProcessId = 0;
    this.dialogHeight = (window.innerHeight - 50).toString() + "px";
    this.dialogWidth = window.innerWidth.toString() + "px";
    this.ReportclosePopup = true;
  }
  ReportclosePopUp() {
    this.ReportclosePopup = false;
  }
  //EOC Pritesh
}
